// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"111":"7ecb6a02","218":"7ecb6a02","340":"7ecb6a02","505":"7ecb6a02","766":"7ecb6a02","893":"7ecb6a02","965":"7ecb6a02"}[chunkId] + ".chunk.css";
};